import axios from "axios";
import { fetchPostDataNibrs } from "@/Components/hooks/Api";

/** Texas state code sent with GetNIBRSErrorSummary (fixed per product rules). */
export const NIBRS_SUMMARY_STATE_TX = "TX";

class NibrsServices {

    getNIBRSOffenseErrors = async ({ queryKey }) => {
        const [_key, payload] = queryKey;
        if (payload) {
            return await axios.post(`/NIBRS/GetNIBRSOffenseErrors`, payload);
        }
        console.warn("payload not provided, NibrsServices.getNIBRSOffenseErrors");
        return null;
    };

    getNIBRSPropertyErrors = async ({ queryKey }) => {
        const [_key, payload] = queryKey;
        if (payload) {
            return await axios.post(`/NIBRS/GetNIBRSPropertyErrors`, payload);
        }
        console.warn("payload not provided, NibrsServices.getNIBRSPropertyErrors");
        return null;
    };

    getNIBRSVictimErrors = async ({ queryKey }) => {
        const [_key, payload] = queryKey;
        if (payload) {
            return await axios.post(`/NIBRS/GetNIBRSVictimErrors`, payload);
        }
        console.warn("payload not provided, NibrsServices.getNIBRSVictimErrors");
        return null;
    };

    getNIBRSOffenderErrors = async ({ queryKey }) => {
        const [_key, payload] = queryKey;
        if (payload) {
            return await axios.post(`/NIBRS/GetNIBRSOffenderErrors`, payload);
        }
        console.warn("payload not provided, NibrsServices.getNIBRSOffenderErrors");
        return null;
    };

    getNIBRSLeftTreeErrors = async ({ queryKey }) => {
        const [_key, payload] = queryKey;
        if (payload) {
            return await axios.post(`/NIBRS/GetNIBRSLeftTreeErrors`, payload);
        }
        console.warn("payload not provided, NibrsServices.getNIBRSLeftTreeErrors");
        return null;
    };

    /**
     * POST NIBRS/GetNIBRSErrorSummary — returns Errors array for incident (TX only).
     * @param {number} incidentId
     * @returns {Promise<Array>}
     */
    getNIBRSErrorSummary = async (incidentId) => {
        if (!incidentId) {
            return [];
        }
        try {
            const res = await fetchPostDataNibrs("NIBRS/GetNIBRSErrorSummary", {
                IncidentId: incidentId,
                State: NIBRS_SUMMARY_STATE_TX,
            });
            if (!res || typeof res !== "object") return [];
            if (Array.isArray(res.Errors)) return res.Errors;
            if (Array.isArray(res.errors)) return res.errors;
            return [];
        } catch (error) {
            console.error("NibrsServices.getNIBRSErrorSummary", error);
            return [];
        }
    };

}

const instance = new NibrsServices();

export default instance;
